import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';
import OfficesMapWidgetLayout from 'components/OfficesMapWidgetLayout';
import { getSharedZonePageSlug } from 'store/SharedZone/selectors';
import { getPointsByZoneSlug, setPointsSearchQuery } from 'store/widgets/OfficesMap/actions';
import {
  getOfficesMapPoints,
  getIsOfficesMapPointsFetched,
  getOfficesMapHeading,
  getOfficesMapHeadlineTagName,
  getOfficesMapSearchQuery,
} from 'store/widgets/OfficesMap/selectors';

const mapStateToProps = (state) => ({
  isMobile: isScreenBelow640(state),
  points: getOfficesMapPoints(state),
  isPointsFetched: getIsOfficesMapPointsFetched(state),
  heading: getOfficesMapHeading(state),
  headlineTagName: getOfficesMapHeadlineTagName(state),
  searchQuery: getOfficesMapSearchQuery(state),
  pageSlug: getSharedZonePageSlug(state),
});

const mapDispatchToProps = {
  getPoints: getPointsByZoneSlug,
  onSearchQueryChange: setPointsSearchQuery,
};

const OfficesMapWidget = connect(mapStateToProps, mapDispatchToProps)(OfficesMapWidgetLayout);

OfficesMapWidget.propTypes = {
  getPoints: PropTypes.func,
  pageSlug: PropTypes.string,
  isMobile: PropTypes.bool,
  points: PropTypes.array,
  isPointsFetched: PropTypes.bool,
  heading: PropTypes.string,
  headlineTagName: PropTypes.string,
  searchQuery: PropTypes.string,
  onSearchQueryChange: PropTypes.func,
  // onSearchQueryBlur: PropTypes.func,
};

export default OfficesMapWidget;
